import React, { createContext, useState } from 'react';
import { useDataContext } from '../hooks/useDataContext.js';

const EpisodePlayersContext = createContext();

const AppProviderMain = ({ children }) => {
    const { data } = useDataContext();
    const [activeEpisodeIndex, setActiveIndex] = useState(false);
    const [clickedButtonIndex, setClickedButtonIndex] = useState(false);
    const [scrollDisabled, setScrollDisabled] = useState(false);
    const [nextVideoPlay, setNextVideoPlay] = useState(null);
    const [previousAudio, setPreviousAudio] = useState(null);

    return (
        <EpisodePlayersContext.Provider
            value={{
                data,
                activeEpisodeIndex,
                setActiveIndex,
                clickedButtonIndex,
                setClickedButtonIndex,
                scrollDisabled,
                setScrollDisabled,
                nextVideoPlay,
                setNextVideoPlay,
                previousAudio,
                setPreviousAudio,
            }}
        >
            {children}
        </EpisodePlayersContext.Provider>
    );
};

export { EpisodePlayersContext, AppProviderMain };
